<fm-context-menu [position]="menuData.clickPosition"
  [isRightClickDisabled]="true"
  class="map-menu-container"
  (closed)="onMenuClosed()"
  (copyCoordinatesClicked)="onCopyCoordinates($event)"
  i18n-menuName="@@S_ACCOUNTSETTINGS_WORKORDER"
  menuName="Work Order"
  [latLng]="menuData.markerInfo?.latLng">
  <fm-context-menu-panel>
    <fm-context-menu-item *ngIf="userPermissions.findNearest"
      [hasSeparator]="true"
      id="lnk-work-order-find-nearest"
      (click)="onFindNearestClicked()">
      <a i18n="@@S_FIND_NEAREST">Find nearest</a>
    </fm-context-menu-item>
    <fm-context-menu-item id="lnk-work-order-zoom-to"
      (click)="onZoomToClicked()">
      <a i18n="@@S_ZOOM_TO">Zoom to</a>
    </fm-context-menu-item>
    <fm-context-menu-item [hasSeparator]="true"
      id="lnk-work-order-street-view"
      [isDisabled]="!menuData.streetViewAvailable"
      (click)="onStreetViewClicked()">
      <a i18n="@@S_STREET_VIEW">Street view</a>
    </fm-context-menu-item>
    <fm-context-menu-item id="lnk-work-order-edit"
      (click)="onEditWorkOrderClicked()">
      <a i18n="@@S_EDIT_WORKORDER">Edit Work Order</a>
    </fm-context-menu-item>
    <fm-context-menu-item id="lnk-work-order-details"
      (click)="onWorkOrderDetailsClicked()">
      <a i18n="@@S_WORK_ORDER_DETAILS">Work Order Details</a>
    </fm-context-menu-item>
    <fm-context-menu-item [hasSeparator]="true"
      id="lnk-work-order-status-history"
      (click)="onWorkOrderStatusHistoryClicked()">
      <a i18n="@@S_WORKORDERSTATUSHISTORY">Work Order Status History</a>
    </fm-context-menu-item>
    <fm-context-menu-item *ngIf="userPermissions.directions"
      id="lnk-work-order-get-directions-to-here"
      (click)="onGetDirectionToClicked()">
      <a i18n="@@S_GET_DIRECTIONS_TO_HERE">Get Directions to here</a>
    </fm-context-menu-item>
    <fm-context-menu-item *ngIf="userPermissions.directions"
      id="lnk-work-order-get-directions-from-here"
      (click)="onGetDirectionFromClicked()">
      <a i18n="@@S_GET_DIRECTIONS_FROM_HERE">Get Directions from here</a>
    </fm-context-menu-item>
    <fm-context-menu-item *ngIf="userPermissions.sendToGarmin"
      id="lnk-work-order-send-location-to-garmin"
      (click)="onLocationToGarminClicked()">
      <a i18n="@@S_SEND_LOCATION_TO_GARMIN">Send location to a Garmin</a>
    </fm-context-menu-item>
  </fm-context-menu-panel>
</fm-context-menu>
